import React, { useEffect, useState } from 'react';
import Paper from '../../components/Paper';
import Text from '../../components/Text';
import Radio from '../../components/Radio';
import { createUseStyles } from 'react-jss';
import {FLAVOUR,currencyName} from '../../config/serverInfo';
export interface PaymentMethodProps {
  method: string;
  cashOnDelivery: number;
  viewCOD: boolean;
  onChange: (name: string, value: any) => any;

}

const PaymentMethod: React.FC<PaymentMethodProps> = ({ method, cashOnDelivery, viewCOD,
  onChange }) => {
  const classes = useStyles();
  
  useEffect(() => {
    
  }, [])
  return (
    <Paper withShadow={false} className="p-3">
      <Text as="h5" className="mb-3" bold>
        Choose payment method
      </Text>
      <div>
        
        {viewCOD && FLAVOUR!='US' ?
          (<label className={classes.label}>
            <div>
              <Radio value="cash_on_delivery"
                onChange={onChange}
                checked={method === 'cash_on_delivery'}
              />
              <Text as="span" className="pb-2 ml-2" bold>
                Cash-on-Delivery (COD)
              </Text>
            </div>
            <div>
              <Text>Fee: {cashOnDelivery} {currencyName}</Text>
            </div>
            
          </label>)
          : (null)}
        <label className={classes.label}>
          <div>
            <Radio value="card"
              onChange={onChange}
              checked={method === 'card'} />
            <Text as="span" className="pb-2 ml-2" bold>
              Credit Card
            </Text>
          </div>
          {FLAVOUR=='US' ? (
            <div>
              <Text>Fee: 0 USD</Text>
            </div>
          ) : (
          <div>
            <Text>Fee: 0 AED</Text>
          </div>
          )}
          
        </label>
      </div>
    </Paper>
  );
};

const useStyles = createUseStyles({
  label: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > div': {
      display: 'flex',
      '& > p': {
        margin: 0,
      },
      '& > div': {
        margin: 0,
      },
    },
  },
});

export default PaymentMethod;
